import React from 'react'
import './Graybg.css'

const Graybg = ({className,children,...rest}) => {
  return (
    <div {...rest} className={`graybg ${className}`}>{children}</div>
  )
}

export default Graybg